import isNil from 'lodash-es/isNil';
import isString from 'lodash-es/isString';
import { DevicesNotifType } from '../../resources/notifications';
export var DeviceFaultEventKind;
(function (DeviceFaultEventKind) {
    /** Sensor is not in a vertical position */
    DeviceFaultEventKind[DeviceFaultEventKind["notVertical"] = 0] = "notVertical";
    /** Sensor has been moved from its previously static position */
    DeviceFaultEventKind[DeviceFaultEventKind["gps"] = 1] = "gps";
    /** Spoon is locked */
    DeviceFaultEventKind[DeviceFaultEventKind["lockedSpoon"] = 2] = "lockedSpoon";
    /** Spoon has been locked 10 times (no period limit) */
    DeviceFaultEventKind[DeviceFaultEventKind["lockedSpoon10Events"] = 3] = "lockedSpoon10Events";
    /** Spoon is unlocked after being stuck */
    DeviceFaultEventKind[DeviceFaultEventKind["unlockedSpoon"] = 4] = "unlockedSpoon";
    /** No message received in the last 24h */
    DeviceFaultEventKind[DeviceFaultEventKind["noMessages"] = 6] = "noMessages";
    /** Return of the messages after a pause */
    DeviceFaultEventKind[DeviceFaultEventKind["noMessagesEnd"] = 7] = "noMessagesEnd";
})(DeviceFaultEventKind || (DeviceFaultEventKind = {}));
/**
 * Ranges in percentage (messages received / messages expected) used to define the quality of the device signal
 */
const deviceSignalQualityRanges = {
    good: [80, 100],
    average: [50, 79],
    bad: [0, 50]
};
const inRange = (n, range) => n >= range[0] && n <= range[1];
/**
 * Converts a percentage into a signal quality flag
 */
export const getSignalQualityFlag = (signalQuality) => {
    let res = null;
    if (!isNil(signalQuality)) {
        if (inRange(signalQuality, deviceSignalQualityRanges.good)) {
            res = 'good';
        }
        else if (inRange(signalQuality, deviceSignalQualityRanges.average)) {
            res = 'average';
        }
        else if (inRange(signalQuality, deviceSignalQualityRanges.bad)) {
            res = 'bad';
        }
    }
    return res;
};
export const allDeviceEventKeys = Object.keys(DeviceFaultEventKind);
/** Some fault event kind signal the end on an event, hance filtering on them is not needed */
export const filterableDeviceFaultEvents = [
    DeviceFaultEventKind.notVertical,
    DeviceFaultEventKind.gps,
    DeviceFaultEventKind.lockedSpoon,
    DeviceFaultEventKind.lockedSpoon10Events,
    DeviceFaultEventKind.noMessages
];
const allDeviceEventValues = Object.values(DeviceFaultEventKind);
export const getDeviceEventName = (event, t) => {
    const castedEvent = isString(event) ? parseInt(event, 10) : event;
    const enumKey = allDeviceEventKeys[allDeviceEventValues.indexOf(castedEvent)];
    return t(`models.device.anomaly_events_names.${enumKey}`, { capitalize: true });
};
export const deviceEventNotifications = Object.values(DevicesNotifType);
export const isDeviceEventNotification = (type) => {
    return deviceEventNotifications.includes(type);
};
